import React, { useState } from 'react'
import { Menu } from '@material-ui/core'
import { CustomArrowDropDown, LocaleFilterButton } from './styles'
import { StyledMenuItem } from '../../../../../theme/Global'

const LocaleFilter = ({
  isLoading,
  maxDropDownHeight,
  eventHandlers,
  locales
}) => {
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClickLocale = (event) => {
    const filter = JSON.parse(event.target.dataset.filter)
    eventHandlers.setFilters({ state: filter })
    eventHandlers.setPageNumber(1)
    setAnchorEl(null)
  }

  const handleClearFilter = () => {
    eventHandlers.setFilters({ state: '' })
    setAnchorEl(null)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <React.Fragment>
      <LocaleFilterButton
        data-testid="locale-filter-menu"
        disabled={isLoading}
        onClick={handleClick}
      >
        Filter By Locale
        {CustomArrowDropDown}
      </LocaleFilterButton>
      <Menu
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        getContentAnchorEl={null}
        MenuListProps={{ style: { maxHeight: maxDropDownHeight } }}
      >
        <StyledMenuItem onClick={handleClearFilter}>Clear Filter</StyledMenuItem>
        {/* @TODO sort by country and then alphabetical */}
        {locales && locales.map((item) => (
          <StyledMenuItem
            data-testid="locale-filter-item"
            key={item.locale.name}
            onClick={handleClickLocale}
            data-filter={JSON.stringify(item)}
          >
            {item.locale.name}
          </StyledMenuItem>
        ))}
      </Menu>
    </React.Fragment>
  )
}

export default LocaleFilter
